import { RouteRecordRaw } from "vue-router"
import { AuthRouteNameEnum } from "@/shared/enums/routes/auth.enum.ts"

export const authRoutes: RouteRecordRaw[] = [
    {
        path: "/auth/login",
        name: AuthRouteNameEnum.login,
        component: () => import("@/pages/auth/LoginPage.vue"),
        meta: {
            title: AuthRouteNameEnum.login,
            layout: "AuthLayout",
        },
    },
    {
        path: "/auth/registration",
        name: AuthRouteNameEnum.register,
        component: () => import("@/pages/auth/RegisterPage.vue"),
        meta: {
            title: AuthRouteNameEnum.register,
            layout: "AuthLayout",
        },
    },
    {
        path: "/auth/password-recovery",
        name: AuthRouteNameEnum.passwordRecovery,
        component: () => import("@/pages/auth/PasswordRecoveryPage.vue"),
        meta: {
            title: AuthRouteNameEnum.passwordRecovery,
            layout: "AuthLayout",
        },
    },
    {
        path: "/auth/password-reset",
        name: AuthRouteNameEnum.passwordReset,
        component: () => import("@/pages/auth/PasswordRecoveryPage.vue"),
        meta: {
            title: AuthRouteNameEnum.passwordReset,
            layout: "AuthLayout",
        },
    },
    {
        path: "/auth/mail-confirmation",
        name: AuthRouteNameEnum.mailConfirmation,
        component: () => import("@/pages/auth/MailConfirmPage.vue"),
        meta: {
            title: AuthRouteNameEnum.mailConfirmation,
            layout: "AuthLayout",
        },
    },
    {
        path: "/auth/confirm-registration",
        name: AuthRouteNameEnum.confirmRegistration,
        component: () => import("@/pages/auth/ConfirmRegistrationPage.vue"),
        meta: {
            title: AuthRouteNameEnum.confirmRegistration,
        },
    },
];
